import { Switch, Drawer } from '@/components/ui'
import DynamicFormField from '@/components/attendees/DynamicFormField'
import type { RegistrationField } from '../types'

interface AttendeeFormDrawerProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  title: string
  submitText: string
  registrationFields: RegistrationField[]
  formValues: Record<string, any>
  onFieldChange: (identifier: string, value: any) => void
  showSendConfirmation?: boolean
  sendConfirmation?: boolean
  onSendConfirmationChange?: (value: boolean) => void
  eventSlug: string
}

export default function AttendeeFormDrawer({
  open,
  onClose,
  onSubmit,
  title,
  submitText,
  registrationFields,
  formValues,
  onFieldChange,
  showSendConfirmation = false,
  sendConfirmation = false,
  onSendConfirmationChange,
  eventSlug
}: AttendeeFormDrawerProps) {
  return (
    <Drawer
      title={title}
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      submitText={submitText}
    >
      <div>
        <div className="space-y-6">
          {/* <div className="mb-4">
            <h3 className="text-base font-semibold mb-4">Attendee Information</h3>
          </div> */}

          {registrationFields.map((field) => (
            <DynamicFormField
              key={field.id}
              field={field}
              value={formValues[field.identifier]}
              onChange={onFieldChange}
              eventSlug={eventSlug}
            />
          ))}

          {/* {showSendConfirmation && onSendConfirmationChange && (
            <div className="pt-4 border-t border-gray-300">
              <div className="flex items-center justify-between">
                <label className="text-sm font-medium">
                  Send Confirmation Email & Whatsapp Message to Attendees
                </label>
                <Switch
                  checked={sendConfirmation}
                  onChange={onSendConfirmationChange}
                />
              </div>
            </div>
          )} */}
        </div>
      </div>
    </Drawer>
  )
}
